import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/components/exo/driversExoShared";

// Séance entourage : proches + classement praticien, rafraîchis toutes les 5 s. Lecture réservée au patient ; le lien proche utilise un token distinct (proche_token).
export function useEntourageSeance(token) {
  const [proches, setProches] = useState([]);
  const [praticienRanking, setPraticienRanking] = useState([]);
  const [praticienSaved, setPraticienSaved] = useState(false);
  const [lang, setLang] = useState("fr");
  const [procheToken, setProcheToken] = useState("");

  useEffect(() => {
    if (!token) return undefined;
    let active = true;
    const poll = async () => {
      try {
        const data = await axios.get(`${API}/drivers-entourage/seances/${token}`).then((r) => r.data);
        if (!active || !data.found) return;
        setProches(Array.isArray(data.proches) ? data.proches : []);
        if (Array.isArray(data.praticien_ranking) && data.praticien_ranking.length) setPraticienRanking(data.praticien_ranking);
        if (data.lang) setLang(data.lang);
        if (data.proche_token) setProcheToken(data.proche_token);
      } catch { /* réseau */ }
    };
    poll();
    const id = setInterval(poll, 5000);
    return () => { active = false; clearInterval(id); };
  }, [token]);

  const savePraticien = async (ranking) => {
    try {
      await axios.post(`${API}/drivers-entourage/seances/${token}/praticien`, { praticien_ranking: ranking });
      setPraticienRanking(ranking);
      setPraticienSaved(true);
      toast.success("Classement du praticien enregistré");
    } catch {
      toast.error("Enregistrement impossible");
    }
  };

  return { proches, praticienRanking, praticienSaved, lang, procheToken, savePraticien };
}
